import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Container, Grid, useMediaQuery } from '@material-ui/core'
import {
  SimpleLoading,
  PromotionalFooterPure,
  GridHLPure,
  DialogSystemGLPure,
  SubtitlePageHLPure,
  HeaderHLPure,
  ButtonAddHLPure,
  SearchBarHLPure,
  FilterHLPure,
  ButtonHLPure,
} from '../../pures'
import DialogDomainContainer from './../../pures/configuration-domains/dialog-domain'
import DialogDeleteDomainPure from './../../pures/dialog-delete-domain/dialog-delete-domain-pure'

import './configuration-domain.css'
import ConfigurationDomainsConfigurationView from './configuration-domains.configuration.view'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

const ConfigurationDomainsView = (props) => {

  let {
    toggleErrorRequesting,
    toggleLoadingRequesting,
    toggleCompletedRequesting,
    showCompletedRequesting,
    showErrorRequesting,
    showLoadingRequesting,
    domains,
    toggleDialogDeleteDomain,
    createNewDomain,
    handleEditDomain
  } = props
  const history = useHistory()
  const { t } = useTranslation()

  let filterOptions = [{
    id: 0,
    'name': t('configurationDomainView.all')
  }]
  const longmatches = useMediaQuery('(max-width:1200px)')

  const globalContainerStyles = {
    display: 'inline-block',
    justifyContent: 'flex-start',
    maxWidth: '100%',
    backgroundColor: 'white',
    width: '100%',
  }

  if (longmatches) {
    globalContainerStyles.marginRight = 0
  }

  const is820 = useMediaQuery('(max-width:820px)')
  const is560 = useMediaQuery('(max-width:560px)')

  let styleHeader1 = {
    fontSize: '14px',
    display: 'flex',
    fontFamily: 'Quicksand',
    alignItems: 'center',
    paddingLeft: '10px'
  }

  let styleHeader3 = {
    fontSize: '14px',
    display: 'flex',
    fontFamily: 'Quicksand',
    alignItems: 'center',
    paddingLeft: '10px'
  }

  let styleHeader4 = {
    fontSize: '14px',
    display: 'flex',
    justifyContent: 'start',
    fontFamily: 'Quicksand',
  }

  if (is820) {
    styleHeader4 = {
      display: 'flex',
      justifyContent: 'end',
      paddingRight: '10px',
      fontSize: '14px',
    }
  }

  if (is560) {
    styleHeader4 = {
      fontSize: '14px',
      display: 'flex',
      justifyContent: 'start',
      fontFamily: 'Quicksand',
      marginLeft: '65px'
    }
  }

  if (is560) {
    styleHeader1 = {
      fontSize: '14px',
      display: 'flex',
      fontFamily: 'Quicksand',
      alignItems: 'center',
      paddingLeft: '0px'
    }
  }

  const [headerTitleinDetail, setHeaderTitleinDetail] = useState({
    clicked: false,
    name: '',
  })
  const [stateNameComponentUser, setStateNameComponentUser] = useState('')
  const [domainSelected, setDomainSelected] = useState({})
  const [nameComponentUser, setNameComponentUser] = useState('')
  const [showDetails, setShowDetails] = useState(false)
  const [searchDominio, setSearchDominio] = useState('')
  const [domainsGrid, setDomainsgrid] = useState([])


  useEffect(() => {
    if (headerTitleinDetail.clicked) {
      setHeaderTitle()
    }
    setHeaderTitle()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nameComponentUser, headerTitleinDetail])

  useEffect(() => {
    if (!domains || nameComponentUser !== '') return
    setDomainsgrid(domains)
  }, [domains, nameComponentUser])

  useEffect(() => {
    let copyDominios = [...domains]
    let newData = copyDominios.filter((dominio) => (
      dominio.name.toLowerCase().includes(searchDominio.toLowerCase()) ||
      dominio.name.includes(searchDominio.toLowerCase())))
    setDomainsgrid(newData)
  }, [searchDominio])


  const setHeaderTitle = () => {
    const name = headerTitleinDetail.name || nameComponentUser
    switch (name) {
      case '':
        return t('configurationDomainView.domains')
      case t('configurationDomainView.newDomain'):
        return t('configurationDomainView.newDomain')
      case t('configurationPanelView.delete.domain.btn'):
        return t('configurationPanelView.delete.domain')
      case t('configurationPanelView.detail.domain.btn'):
        return t('configurationPanelView.detail.domain.title')
      default:
        return
    }
  }

  useEffect(() => {
    if (domainSelected && domainSelected.id) {
      setNameComponentUser(t('configurationPanelView.detail.domain.btn'))
      setShowDetails(true)
    }
  }, [domainSelected])


  const backGrid = () => {
    setShowDetails(false)
    setNameComponentUser('')
    setHeaderTitleinDetail({ clicked: false, name: '' })
  }

  const sendNextPage = (page) => {
    setNameComponentUser(page)
    setShowDetails(true)
  }

  const handleChangeSearch = (e) => {
    setSearchDominio(e.target.value)
  }

  return (
    <div className='standard-wrapper'>
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <Container spacing={4} lg={12} md={12} style={globalContainerStyles}>
          {props.showLoadingRequesting ? (
            <DialogSystemGLPure
              toggleLoadingRequesting={props.toggleLoadingRequesting}
              showLoadingRequesting={props.showLoadingRequesting}
            />
          ) : null}
          {props.showCompletedRequesting ? (
            <DialogSystemGLPure
              showCompletedRequesting={props.showCompletedRequesting}
              toggleCompletedRequesting={props.toggleCompletedRequesting}
            />
          ) : null}
          {props.showErrorRequesting ? (
            <DialogSystemGLPure
              toggleErrorRequesting={props.toggleErrorRequesting}
              message={props.message}
              showErrorRequesting={props.showErrorRequesting}
            />
          ) : null}

          <Container
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
            class='configurationDomainView-container-table'
          >
            <Grid
              item
              lg={12}
              md={12}
              xs={12}
              sm={12}
              className='configurationDomainView-header'
            >
              <HeaderHLPure
                title={setHeaderTitle()}
              />
            </Grid>
            <Grid
              container
              className='configurationDomainView-domains-body'
              xs={12}
              lg={12}
              md={12}
              sm={12}
              es={12}
            >
              {showDetails && nameComponentUser ? (

                <ConfigurationDomainsConfigurationView
                  {...props}
                  nameComponentUser={nameComponentUser}
                  backGrid={backGrid}
                  setHeaderTitleinDetail={setHeaderTitleinDetail}
                  setNameComponentUser={setNameComponentUser}
                  setShowDetails={setShowDetails}
                  toggleErrorRequesting={toggleErrorRequesting}
                  toggleLoadingRequesting={toggleLoadingRequesting}
                  toggleCompletedRequesting={toggleCompletedRequesting}
                  showCompletedRequesting={showCompletedRequesting}
                  showErrorRequesting={showErrorRequesting}
                  showLoadingRequesting={showLoadingRequesting}
                  stateNameComponentUser={stateNameComponentUser}
                  setStateNameComponentUser={setStateNameComponentUser}
                  sendNextPage={sendNextPage}
                  createNewDomain={createNewDomain}
                  domainSelected={domainSelected}
                  handleEditDomain={handleEditDomain}
                />
              ) : (
                <>
                  <Grid
                    item
                    xs={12}
                    lg={12}
                    md={12}
                    sm={12}
                  >
                    <div className='configuration-domains-btns'>
                      <ButtonAddHLPure
                        iconAdd={true}
                        nameBtn={t('configurationDomainView.newDomain')}
                        onClickBtn={() => sendNextPage(t('configurationDomainView.newDomain'))}
                      />
                      <SearchBarHLPure
                        placeholder={t('configurationPanelView.placeholder.search')}
                        onSearchChange={((e) => handleChangeSearch(e))}
                      />
                      <FilterHLPure
                        options={filterOptions}
                        nameOption='name'
                        valueItem='id'
                        onFilterChange={() => console.log('')}
                      />
                    </div>
                  </Grid>
                  <Grid className='configurationDomainView-gridTable'>
                    <GridHLPure
                      dataGrid={domainsGrid}
                      skip={0}
                      take={6}
                      onSelectedItem={setDomainSelected}
                      setNameComponentUser={setNameComponentUser}
                      setShowDetails={setShowDetails}
                      titleRow1={t('configurationPanelView.domain.grid')}
                      titleRow3={t('configurationPanelView.administrator.grid')}
                      titleRow4={t('configurationPanelView.actions.grid')}
                      column2Status={false}
                      columnThree={!is560}
                      columnFour={true}
                      fieldRow1={'name'}
                      fieldRow3={'email'}
                      iconOneActive
                      iconTwoActive
                      labelOneActions={t('configurationPanelView.delete.domain.btn')}
                      labelTwoActions={t('configurationPanelView.detail.domain.btn')}
                      activeDialog1
                      btnOpenDialog1={(dataItem) => toggleDialogDeleteDomain(dataItem)}
                      btnOpenDialog2={(dataItem) => {
                        setDomainSelected(dataItem)
                        setNameComponentUser(t('configurationPanelView.detail.domain.btn'))
                        setShowDetails(true)
                      }}
                      styleCol1={'configurationDomainsView-style-col-1'}
                      styleCol3={'configurationDomainsView-style-col-3'}
                      styleCol4={'configurationDomainsView-style-col-4'}
                      styleHeader1={styleHeader1}
                      styleHeader4={styleHeader4}
                      styleHeader3={styleHeader3}
                      labelsColumnsNoPadding={false}
                      minHeight={'0'}
                    />
                  </Grid>
                </>
              )}
              {!nameComponentUser &&
                <Grid
                  container
                  style={{ justifyContent: 'flex-end' }}
                >
                  <ButtonHLPure
                    nameBtn={t('button.return')}
                    onClickBtn={() => history.push('/configuration')}
                  />
                </Grid>
              }
              {props.visibleDialogDeleteRequest && (
                <DialogDeleteDomainPure
                  {...props}
                  toggleDialogDeleteDomain={props.toggleDialogDeleteDomain}
                  deleteDomain={props.deleteDomain}
                  toggleLoadingRequesting={props.toggleLoadingRequesting}
                  toggleCompletedRequesting={props.toggleCompletedRequesting}
                  toggleErrorRequesting={props.toggleErrorRequesting}
                  dataItem={props.userInEdit}
                />
              )}
              <Grid item xs={12} lg={12} md={12} sm={12}>
                <PromotionalFooterPure />
              </Grid>
            </Grid>
          </Container>
        </Container>
      )}
    </div>
  )
}

export { ConfigurationDomainsView as default }
